import React from 'react';
import { WorkplaceWorkerItem } from './WorkplaceWorkersListItem';
// @ts-ignore
import styles from './WorkplaceWorkersListItemGridView.module.scss';
import UserAvatarImage from '../../../../../../Components/UserAvatar/UserAvatarImage';
import WorkplaceWorkersItemStatusBadge from '../WorkplaceWorkersItemStatusBadge/WorkplaceWorkersItemStatusBadge';
import { WorkplaceWorkersStatus } from '../../../../Enums/WorkplaceWorkersStatus.enum';

interface Props {
	item: WorkplaceWorkerItem;
	onClick: () => void;
}

const WorkplaceWorkersListItemGridView: React.FC<Props> = ({
	item,
	onClick,
}) => {
	return (
		<div className={styles.item} onClick={onClick}>
			<div className={styles.image}>
				<UserAvatarImage
					userId={item.id}
					profileImageUrl={item.profileImageUrl}
				/>
			</div>
			<div className={styles.name}>{item.profile?.fullName || item?.email}</div>
			<div className={styles.badgeWrapper}>
				<WorkplaceWorkersItemStatusBadge
					status={item.rootWorkplaceMemberStatus as WorkplaceWorkersStatus}
				/>
			</div>
		</div>
	);
};

export default WorkplaceWorkersListItemGridView;
